var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCzechRepublic = function SvgCzechRepublic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "CzechRepublic_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M-74 0h682.7v512H-74z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    clipPath: "url(#CzechRepublic_svg__a)",
    transform: "translate(69.4)scale(.94)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e80000",
    d: "M-74 0h768v512H-74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-74 0h768v256H-74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00006f",
    d: "m-74 0 382.7 255.7L-74 511z"
  }))));
};
export default SvgCzechRepublic;